import { RaceDetailDto, RaceSummaryDto } from "@aoe/client";
import { createReducer, on } from "@ngrx/store";
import { raceActions } from "./race.actions";

export interface RaceState {
    races: Array<RaceSummaryDto>;
    nb: number;
    loading: boolean;
    error?: any;
    warning?: any;
    info?: any;
    selectedRaceDetail: RaceDetailDto | null;
    selectRaceId: string | null
}

export const initialeState: RaceState = {
    races: [],
    nb: 0,
    loading: false,
    selectedRaceDetail: null,
    selectRaceId: null
};

export const raceReducer = createReducer(
    initialeState,
    // Écoute aussi loadRacesByEventId pour passer loading à true
    on(
        raceActions.loadRace,
        raceActions.loadRaceById,
        state => ({
            ...state,
            loading: true,
            error: null
        })
    ),
    on(
        raceActions.loadSuccess, (state, res) => ({
            ...state,
            loading: false,
            races: res.data?.races ?? [],
            nb: res.data?.nb ?? 0,
            info: res.info,
            warning: res.warning,
        })
    ),
    on(
        raceActions.loadFailed, (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })
    ),
    on(
        raceActions.loadByIdSuccess, (state, res) => ({
            ...state,
            loading: false,
            info: res.info,
            warning: res.warning,
            s: res.data ?? null,
            selectedRaceDetail: res.data ?? null,
            selectRaceId: res.data ? res.data.id : null
        })
    ),
    on(
        raceActions.loadByIdFailed, (state, res) => ({
            ...state,
            loading: false,
            error: res.error
        })
    ),
    on(
        raceActions.resetSelectedRace, state => ({
            ...state,
            selectedRaceDetail: null,
            selectRaceId: null
        })
    )
);